import { useQuery } from "@tanstack/react-query";
import { contractorApi } from "../api/contractorApi";
import { ContractorGraph } from "../contractorTypes";
import { FilterItem } from "../../../shared/context/FilterContext";
import { extractFilterValues } from "../../../lib/filterUtils";

export const useFetchGraph = ({ quickFilters }: { quickFilters: any }) => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-graph", quickFilters],
        queryFn: () => {
            const params = {
                workstream_id: extractFilterValues(quickFilters.workstream) || null,
                site_id: extractFilterValues(quickFilters.site) || null,
                programme_id: extractFilterValues(quickFilters.programme) || null,
                region_id: extractFilterValues(quickFilters.region) || null,
                worktype_group_id: extractFilterValues(quickFilters['worktype-group']) || null,
                project_year: extractFilterValues(quickFilters.projectYear) || null,
            };
            return contractorApi.fetchGraph(params);
        },
    });

    return {
        data: data as ContractorGraph,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};
